import { gql } from 'graphql-tag';

import { TypedDocumentNode } from '@apollo/client';

import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import { CardPaymentMerchantEnum } from '@libs/backend-common';

import { CurrencyType } from 'src/constants';

export type AddNewCardV2Response = {
  addNewCard: DefaultApiResponse<{ redirectUrl: string }>;
};

export type AddNewCardV2Args = {
  assetCode: CurrencyType;
  isManualSave?: boolean;
  merchantName?: CardPaymentMerchantEnum;
  responseUrlPath?: string;
};

export const addNewCardV2Mutation: TypedDocumentNode<
  AddNewCardV2Response,
  DefaultArg<AddNewCardV2Args>
> = gql`
  mutation AddNewCardV2($record: AddNewCardRecord!) {
    addNewCard: addNewCardV2(record: $record) {
      redirectUrl
    }
  }
`;
